import React from 'react';
import { useItemsInView } from '../../utils/useItemsInView';
import { PLAYBACK_CONTAINER_ITEM, } from '../../types/templates/widgets/items/ISkyfirePlaybackContainerItem';
import HorizontalItem, { getItemSize, HorizontalItemSize } from './items/HorizontalItem';
import PlaybackContainerItem from './items/PlaybackContainerItem';
function isPlaybackContainerItem(item) {
    return item.interface === PLAYBACK_CONTAINER_ITEM;
}
export default function FeaturedShoveler(props) {
    const { header, items, seeMoreItem, allowEmptyHeader } = props.data;
    const callbackRef = useItemsInView(props.onViewed);
    if (items === null || items === void 0 ? void 0 : items.length) {
        const sizes = items.map((item) => isPlaybackContainerItem(item)
            ? HorizontalItemSize.Small
            : getItemSize(item));
        const maxSize = sizes.reduce((acc, size) => (size > acc ? size : acc), HorizontalItemSize.Small);
        return (React.createElement("div", null,
            React.createElement("music-shoveler", { key: header, "see-all": seeMoreItem === null || seeMoreItem === void 0 ? void 0 : seeMoreItem.text, "primary-text": header, "allow-empty-header": allowEmptyHeader, onmusicSeeAllActivate: props.handleSelected.bind(null, seeMoreItem === null || seeMoreItem === void 0 ? void 0 : seeMoreItem.primaryLink.onItemSelected) }, items.map((item, i) => isPlaybackContainerItem(item) ? (React.createElement(PlaybackContainerItem, { ref: callbackRef, key: i, data: item, handleSelected: props.handleSelected })) : (React.createElement(HorizontalItem, { ref: callbackRef, key: i, data: item, handleSelected: props.handleSelected, size: sizes[i], parentSize: maxSize }))))));
    }
    return null;
}
